import Roles from "@/router/roles";
import APIsList from '@/views/Admin/APIs/APIsList'
import APIDetails from '@/views/Admin/APIs/APIDetails'
import FrontsList from '@/views/Admin/Fronts/FrontsList'
import FrontDetails from '@/views/Admin/Fronts/FrontDetails'
import ServiceAccountsList from '@/views/Admin/ServiceAccounts/ServiceAccountsList'
import ServiceAccountDetails from '@/views/Admin/ServiceAccounts/ServiceAccountDetails'
import OrganizationsList from '@/views/Admin/Organizations/OrganizationsList'
import OrganizationDetails from '@/views/Admin/Organizations/OrganizationDetails'
import ScopesList from '@/views/Admin/Scopes/ScopesList'
import ScopeDetails from '@/views/Admin/Scopes/ScopeDetails'
import RolesList from '@/views/Admin/Roles/RolesList'
import UsersList from '@/views/Admin/Users/UsersList'

const adminRoutes = [
    {
        path: '/admin/apis',
        name: 'APIs',
        component: APIsList,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/apis/:apiId',
        name: 'API details',
        component: APIDetails,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/fronts',
        name: 'Fronts',
        component: FrontsList,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/fronts/:frontId',
        name: 'Front Details',
        component: FrontDetails,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/service-accounts',
        name: 'Service accounts',
        component: ServiceAccountsList,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/service-accounts/:serviceAccountId',
        name: 'Service account details',
        component: ServiceAccountDetails,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/organizations',
        name: 'Organizations',
        component: OrganizationsList,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: '/admin/organizations/:organizationId',
        name: 'Organization Details',
        component: OrganizationDetails,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: "/admin/scopes",
        name: 'Scopes',
        component: ScopesList,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: "/admin/scopes/:scopeId",
        name: 'Scope details',
        component: ScopeDetails,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: "/admin/roles",
        name: 'Roles',
        component: RolesList,
        meta: { authorize: [Roles.SuperAdmin] },
    },
    {
        path: "/admin/users",
        name: "Admin Users",
        component: UsersList,
        meta: { authorize: [Roles.SuperAdmin] },
    }
]

export default adminRoutes;
